<template>
  <sky-charts ref="chart"
              :config="chartConfig"
              legendPosition="bottom"
              :showTitle="false"
              :showShadow="false"
              :colors="colors"
              :extend="extend"
              :chartData="data">
    <div slot="header"
         class="header">
      <div class="title">国家/地区</div>
      <div>{{ selectName }}TOP5</div>

      <el-select v-model="selectValue"
                 placeholder="展示次数"
                 size="mini"
                 @change="changeNum">
        <el-option v-for="item in audienceReportCount"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>

    </div>
  </sky-charts>
</template>

<script>
import apiConf from "@/client/apiConfig/apiConfig";
import mixins from "./ga_mixins";
import filters from "@/mixins/filters.js";
import { audienceReportCount } from "@/common/dictionary.js";

export default {
  name: "fb-contry-bar",
  mixins: [mixins],
  data () {
    const that = this
    return {
      audienceReportCount,
      selectValue: "impressions", //排序字段
      selectName: "展示次数",
      colors: ["#3DA1FF"],
      extend: {
        series: {
          type: 'bar',
          label: {
            show: false,
            position: "right",
          },
          smooth: false
        },
        grid: {
          right: 20,
        },
        tooltip: {
          formatter (val) {
            let _val = val[0]
            let index = that.data.length - 1 - _val.dataIndex
            let percentage = _val.seriesName + 'Percentage'
            let name = that.selectName.substring(0, 2)
            let format = _val.seriesName === 'exchangeRateCost' ? 'rmb' : 'thousands'
            return `
                ${_val.name}</br>
                ${that.selectName}：${filters.filters[format](_val.value)}</br>
                ${name}占比:${that.data[index][percentage]}%
            `;
          }
        },
        legend: {
          show: false
        }
      },
      chartConfig: {
        type: "veBar",
        columns: [],
        chartSettings: {
          dataOrder: {
            label: 'impressions',
            order: 'desc'
          }
        }
      },
      data: null,
      dataMap: {
        'covers': 'countryRegionCoversList',
        'impressions': 'countryRegionImpressionsList',
        'exchangeRateCost': 'countryRegionExchangeRateCostList'
      }
    };
  },
  watch: {
    condition: {
      handler (val) {
        if (val) {
          this.data = val.countryRegionImpressionsList;
          this.chartConfig.columns = [
            'countryRegionCn',
            'impressions'
          ]
        } else {
          this.$nextTick(() => this.$refs.chart.dataEmpty = true)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 改变排序字段
    changeNum (val) {
      this.selectValue = val;
      this.selectName = audienceReportCount.find(item => item.value === val).label
      this.data = this.condition[this.dataMap[val]]
      this.chartConfig.columns = ['countryRegionCn', val]
      this.chartConfig.chartSettings.dataOrder.label = val
    },
  }
};
</script>

<style scoped lang="scss">
.chart-title {
  padding-bottom: 24px;
  color: #333;
  font-weight: bold;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 16px;
    font-weight: bold;
  }

  color: #000;
  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
